import DashboardManagerModal from "./container"
import './style.css';
/** 
 * @module DashboardManagerModal
 * @description 戰情室管理員, 刪除。
 */
export default DashboardManagerModal;